import closeChatSvg from "../../../assets/images/CloseChat.svg";

interface Props {
  setOpenCloseChatPopup: (value: boolean) => void;
  handleCloseChat: () => void;
}

const CloseChat = ({ setOpenCloseChatPopup , handleCloseChat }: Props) => {
  return (
    <div className="q-close-chat-popup-container" onClick={() => setOpenCloseChatPopup(false)}>
      <div className="q-close-chat-popup-content" onClick={(e) => e.stopPropagation()}>
        <div className="q-close-chat-popup-icon">
          <img src={closeChatSvg} alt="close chat" />
        </div>
        <div className="q-close-chat-popup-text">
          <div>Close chat?</div>

          <div>Once closed, the chat will be locked. Continue?</div>
        </div>

        <div className="q-helphub-satisfied-close-chat" style={{maxWidth: "100%", width: "100%"}}>
          <div
            className="q-helphub-close-chat"
            style={{ color : '#181818'}}
            onClick={() => setOpenCloseChatPopup(false)}
          >
            Cancel
            
          </div>
          <div
            className="q-helphub-close-chat"
            style={{background: "#ED0A34", color: "white",borderColor: '#ED0A34'}}
            onClick={() => handleCloseChat()}
          >
           Close chat
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloseChat;
